import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Clock, IndianRupee, ArrowRight } from "lucide-react";
import Seo from "../components/Seo";

export default function Visa() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/visa").then(r => setItems(r.data)); }, []);
  return (
    <div className="pt-24 lg:pt-28">
      <Seo title="Visa Services — Fast Visa Assistance" path="/visa" description="End-to-end visa assistance for Singapore, Dubai, Vietnam, Australia, USA, UK, Schengen and Japan. 15,000+ successful applications, expert document guidance." />
      <section className="container-p">
        <span className="section-label">Visa Services</span>
        <h1 className="h1 mt-3">Visa assistance for 9+ countries</h1>
        <p className="muted mt-4 max-w-2xl">End-to-end guidance — from documents to appointment booking. Our visa specialists have processed 15,000+ successful applications.</p>
      </section>
      <section className="container-p mt-12 mb-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(v => (
          <Link key={v.slug} to={`/visa/${v.slug}`} className="card-glass overflow-hidden group hover:-translate-y-1 transition" data-testid={`visa-card-${v.slug}`}>
            <div className="aspect-[16/10] overflow-hidden bg-slate-100"><img src={v.image} alt={v.country} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" /></div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-2"><span className="text-2xl">{v.flag}</span><h3 className="h3">{v.country}</h3></div>
              <div className="flex items-center gap-4 text-xs muted mt-3">
                <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {v.processing_time}</span>
                <span className="flex items-center gap-1"><IndianRupee className="w-3.5 h-3.5" /> from ₹{v.fees_from.toLocaleString("en-IN")}</span>
              </div>
              <div className="mt-4 text-sm font-semibold text-[#006CE4] flex items-center gap-1">Apply Now <ArrowRight className="w-4 h-4" /></div>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
